/**
 * Утилиты для форматирования валюты
 */

/**
 * Форматирует сумму с символом рубля
 * @param amount - сумма для форматирования
 * @returns отформатированная строка с символом рубля
 * 
 * @example
 * formatRubles(100.5) // "100.50 ₽"
 * formatRubles(1000) // "1 000.00 ₽"
 */
export const formatRubles = (amount: number): string => {
  return amount.toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Форматирует сумму с символом рубля (кратко, без копеек если целое)
 * @param amount - сумма для форматирования
 * @returns отформатированная строка с символом рубля
 * 
 * @example
 * formatRublesShort(100.5) // "100.50 ₽"
 * formatRublesShort(1000) // "1 000 ₽"
 */
export const formatRublesShort = (amount: number): string => {
  if (amount === Math.floor(amount)) {
    return amount.toLocaleString('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  return amount.toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Форматирует валюту (универсальная функция)
 * @param amount - сумма
 * @param currency - код валюты (RUB, USD, EUR, KZT)
 * @returns отформатированная строка с символом валюты
 */
export const formatCurrency = (amount: number, currency: string = 'RUB'): string => {
  return amount.toLocaleString('ru-RU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
